require('./bootstrap');

$('[class^="form-"]').on('click', function() { 
	if($(this).hasClass('border-danger')) { 
		$(this).removeClass('border-danger text-danger'); 
		$(this).siblings('label').removeClass('text-danger'); 
	}; 
});

